import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducers';
import sagas from './sagas';
import signalRMiddleware from './middlewares/signalRMiddleware';

const createStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // In actions ko check nahi karega
          ignoredActions: [
            'pos/setMyOrders',
            'pos/setUserAddress',
            'pos/setUserAddressValue',
          ],
          // Payload ke andar in paths ko ignore karega
          ignoredActionPaths: [
            'payload.headers',
            'payload.config',
            'payload.request',
          ],
          // State ke andar in variables ko ignore karega
          ignoredPaths: [
            'pos.myOrders',
            'pos.saveUserAddress',
            'pos.userAddress',
            'pos.preInvoices',
          ],
        },
      }).concat(sagaMiddleware, signalRMiddleware),
  });

  sagaMiddleware.run(sagas);

  return store;
};

export default createStore;